import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { DocumentoTipoService } from '../services/documento-tipo.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentoTipoResolver implements Resolve<boolean> {
  constructor(private service: DocumentoTipoService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
